import PortalReactDOM from 'react-dom';
const Portal = (props) => {
    return PortalReactDOM.createPortal(props.children,props.container)
}
export default Portal;